"use client";
//#region packages/@mantine/core/src/components/Badge/Badge.module.css
var Badge_module_default = {
	"root": "m_347db0ec",
	"root--dot": "m_fbd81e3d",
	"label": "m_5add502a",
	"section": "m_91fdda9b"
};
//#endregion
export { Badge_module_default as default };

//# sourceMappingURL=Badge.module.mjs.map